/* eslint-disable @typescript-eslint/naming-convention */
import type { ITag } from 'services/api/entities';

export enum SortType {
  Popular = 'quality_score:desc',
  Recent = 'created_at:desc',
}

export type TagsType = Record<string, ITag>;
export type SelectedTagsType = Record<string, Array<ITag>>;
export type AppliedFiltersType = {
  min_Duration?: number;
  max_Duration?: number;
  sort_by?: Array<SortType>;
};

export type TagStore = {
  tags: TagsType;
  selectedTags: SelectedTagsType;
  appliedFilters: AppliedFiltersType;
  [key: string]:
    | ReadonlyArray<string>
    | TagsType
    | SelectedTagsType
    | AppliedFiltersType;
};
